import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { DropDownListComponent } from "@progress/kendo-angular-dropdowns";
import {
  ColumnComponent,
  DataStateChangeEvent,
  GridComponent,
  GridDataResult,
  PageChangeEvent,
  PageSizeItem,
  SelectAllCheckboxState,
  SelectionEvent,
} from "@progress/kendo-angular-grid";
import { PopupComponent } from "@progress/kendo-angular-popup";
import { State, process } from "@progress/kendo-data-query";
import * as moment from "jalali-moment";
import { Moment } from "jalali-moment";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { isNumber } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { NumberType, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import {
  AggregatesInfo,
  HttpCommonService,
  LocalStoreManager,
  LookupService,
  ShowToastrService,
} from "projects/sepidz-web-framework/src/lib/services";
import { MonthsNameService } from "projects/sepidz-web-framework/src/lib/services/monthe-name.service";
import { Observable, Subject } from "rxjs";
import { pairwise, take, takeUntil } from "rxjs/operators";

@Component({
  selector: "editable-grid",
  templateUrl: "./editable-grid.component.html",
  styleUrls: ["./editable-grid.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class EditableGridComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  LookupData: Dictionary = [];
  @ViewChild(GridComponent)
  public grid: GridComponent;
  aggregatesInfo: AggregatesInfo[];
  currentLookup: any;
  rowseleted: boolean = false;
  public selectAllState: SelectAllCheckboxState = "unchecked";
  @Input() isMulti: boolean = false;
  mySelection: number[] = [];
  selectedRows: any[] = [];
  public isNew: boolean;
  public state: State = {
    filter: {
      logic: "and",
      filters: [],
    },
    group: [],
  };
  @Input() filtering: boolean = false;
  @Input() SelectById: string = "Id";
  @Input() newdefaultRowTregger: (row: any, parameter: any) => any;
  @Input() DefaultValues: Dictionary = [];
  @Input() aggregatesColumnName: string;
  isDisabled: boolean = false;
  ngUnsubscribe = new Subject<void>();
  @Output() onRows_Selected = new EventEmitter<any[]>();
  @Output() valueChange = new EventEmitter<any>();
  @Output() valueChanges = new EventEmitter<any>();
  @Output() onLookupChanges = new EventEmitter<any>();
  @Output() formGroupValueChanges = new EventEmitter<any>();
  @Output() onRowSelected = new EventEmitter<any>();
  @Output() valueChangeByApiName = new EventEmitter<any>();
  @Output() afterSaved = new EventEmitter<any>();
  @Output() afterDeleted = new EventEmitter<any>();
  @Input() height: number = 30;
  @Input() formTitle: string;
  @Input() formTitle2: string;
  @Input() RowNumberName: string;
  @Input() columns: form_control[] = [];
  @Input() isAdd: boolean = true;
  @Input() isEdit: boolean = true;
  @Input() isDelete: boolean = true;
  @Input() noReduplicative: boolean = false;
  @Input() customDataList: (dataItem: any) => Observable<any[]>;
  @Input() hideToolber: boolean = false;
  @Output() CompleteData = new EventEmitter<any>(true);
  @Input() showMap: boolean = false;
  @Input() addRowAfterClickOutSideRow: boolean = false;
  @Input() addRowAfterClickOutSideRowColumnName: string;
  @Input() rowEditableKeyNotAllow: string;
  @Input() noAutoFitColumns: boolean = false;
  @Input() paging: boolean = false;
  @Input() pagingSize = 10;

  formGroup: UntypedFormGroup;
  _dataList: any[];
  loadingData: boolean = false;
  gridData: any[];
  public gridView: GridDataResult;
  isValueChanging: boolean = false;
  currentColumnIndex: number = null;

  @Input()
  get dataList(): any[] {
    return this._dataList;
  }
  set dataList(value: any[]) {
    if (this._dataList !== value) setTimeout(() => this.fitColumns(), 200);
    this._dataList = value;
    if (this.dataList && this.dataList.length > 0)
      this.gridData = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    else this.gridData = [];
    if (this.filtering) this.dataStateChange(this.state as DataStateChangeEvent);
    this.cd.markForCheck();
  }
  rowIsEditing: boolean = false;
  getIdName(name: string): string {
    return `grd${name}`;
  }
  editedRow: any;
  editedRowIndex: number = 0;
  getColumnIndex(colIndex: number) {
    let index: number = -1;
    let ColumnName: string;
    this.grid.columns
      .toArray()
      .filter((x) => x.isVisible)
      .forEach((x) => {
        index = index + 1;
        if (index == colIndex) ColumnName = x["field"];
      });
    return ColumnName;
  }
  @HostListener("document:mousedown", ["$event"])
  dmu(e: KeyboardEvent) {
    if (document.hidden) return;
    if (this.formGroup) this.getSelected(this.formGroup.value);
    const clickedCellElement = e?.target["closest"]("td[kendogridlogicalcell]");
    if (!e.target["closest"]("tr[kendogridlogicalrow]") && !e.target["closest"]("kendo-popup") && !e.target["closest"](".dp-calendar-wrapper")) {
      this.currentColumnIndex = null;
      if (this.formGroup?.valid) {
        this.saveCurrent();
        if (this.addRowAfterClickOutSideRow) this.addHandler();
      }
    } else if (clickedCellElement) {
      const currentColumns = this.grid.columnsContainer?.allColumns["_results"];
      const col = currentColumns?.find((x) => x.leafIndex === clickedCellElement?.cellIndex);
      if (col?.editable) this.currentColumnIndex = col?.leafIndex;
      else this.currentColumnIndex = null;
    }
  }
  @HostListener("window:keydown", ["$event"])
  cs(e: KeyboardEvent) {
    if (document.hidden) return;
    if (e.altKey && e.shiftKey && (e.key === "n" || e.key === "N" || e.key === "أ")) {
      e.preventDefault();
      this.addHandler();
    }
    if (e.ctrlKey && e.altKey && (e.key === "s" || e.key === "S" || e.key === "س")) {
      e.preventDefault();
      this.saveCurrent();
    }
    if (this.formGroup) this.getSelected(this.formGroup.value);
    if (e.key === "Tab" && this.formGroup?.valid && (this.currentColumnIndex !== null || this.addRowAfterClickOutSideRowColumnName)) {
      const currentColumns = this.grid.columnsContainer?.allColumns["_results"];
      const lastIndex = this.currentColumnIndex;
      this.currentColumnIndex = currentColumns?.find((x) => x.editable && x.leafIndex > this.currentColumnIndex)?.leafIndex;
      if (
        (lastIndex && lastIndex === currentColumns?.length - 1) ||
        this.getColumnIndex(this.grid.activeCell.colIndex) === this.addRowAfterClickOutSideRowColumnName
      ) {
        this.saveCurrent();
        if (this.addRowAfterClickOutSideRow) this.addHandler();
      }
    }
  }

  constructor(
    private lookupservice: LookupService,
    private sts: ShowToastrService,
    private monthsnameService: MonthsNameService,
    private ngZone: NgZone,
    private cd: ChangeDetectorRef,
    public selectorService: SelectorService,
    private _httpCommonService: HttpCommonService,
    public storage: LocalStoreManager
  ) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (this.formGroup) this.valueChanges.emit(this.formGroup);
    this.cd.markForCheck();
  }
  ngAfterViewInit(): void {}
  onGridSelectionChange(event: SelectionEvent) {
    this.valueChanges.emit(event);
  }
  ngOnInit(): void {
    if (!this.dataList) this.dataList = [];
    this.columns.forEach((x) => {
      if (!x.listVisible) x.columnWidth = 0;
      if (x.apiName && !this.hasMultiColumns(x.columnsName)) this.setDropdownlist(x.apiName, x.systemName, x.category, x.name);
    });
    this.setColumnWith();
    this.fitColumns();
    if (this.paging) {
      this.state.take = this.pagingSize;
      this.state.skip = 0;
    }
  }

  public dataStateChange(state: State): void {
    this.state = state;
    if (this.state.filter.filters && !this.columns.some((x) => x["custom"])) {
      this.state.filter.filters = this.state.filter.filters.filter((x) => x["field"] !== "GoodsTitle");
      this.state.filter.filters.forEach((x) => {
        if (x["field"] === "GoodsId") x["field"] = x["field"].replace("Id", "Title");
      });
    }
    if (!this.filtering) return;
    this.gridView = process(this._dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) as any[], {
      sort: this.state.sort,
      filter: this.state.filter,
      skip: this.state.skip,
      take: this.state.take,
    });
    if (this.gridView.data.length <= 0 && !this.columns.some((x) => x["custom"]))
      this.gridView.data = this._dataList.filter((x) => x.State !== RowState.Delete && x.State !== RowState.Detached) as any[];
    this.cd.markForCheck();
  }

  clearFilter() {
    this.state.filter.filters = [];
    this.grid.filter = { logic: "and", filters: [] };
    this.dataStateChange(this.state);
  }

  setChanges() {
    this.formGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && !this.isValueChanging) {
        this.isValueChanging = true;
        this.valueChanges.emit(this.formGroup);
        this.isValueChanging = false;
      }
    });
    this.formGroup.valueChanges.pipe(takeUntil(this.ngUnsubscribe), pairwise()).subscribe(([prev, next]) => {
      for (const key in prev) {
        if (prev[key] !== next[key])
          this.formGroupValueChanges.emit({
            newValue: next[key],
            oldValue: prev[key],
            field: key,
            formGroup: this.formGroup,
            LookupData: this.LookupData,
          });
      }
      return false;
    });

    this.cd.markForCheck();
  }
  setValue(key: string, value: any) {
    if (!this.formGroup.controls[key]) this.formGroup.addControl(key, new UntypedFormControl(value));
    else this.formGroup.controls[key].setValue(value);
  }
  GetLookupData(keyName: string) {
    return this.selectorService.getDataList(keyName) ?? this.LookupData[keyName];
  }
  setFormGroup(entity: any = null) {
    let group: any = {};

    this.columns.forEach((col) => {
      switch (col.textType) {
        case "text":
          group[col.name] =
            col.required && col.listVisible
              ? new UntypedFormControl(!entity ? "" : entity[col.name] || "", Validators.required)
              : new UntypedFormControl(!entity ? "" : entity[col.name] || "");
          break;
        case "checkbox":
          group[col.name] =
            col.required && col.listVisible
              ? new UntypedFormControl(!entity ? false : entity[col.name] || false, Validators.required)
              : new UntypedFormControl(!entity ? false : entity[col.name] || false);
          break;
        case "number":
          if (col.inputMask && entity[col.name] && typeof entity[col.name] === "number") {
            entity[col.name] = this.getMaskedAmount(entity[col.name], col.inputMask);
          }
          group[col.name] =
            col.required && col.listVisible
              ? new UntypedFormControl(!entity ? null : entity[col.name], Validators.required)
              : new UntypedFormControl(!entity ? null : entity[col.name]);
          break;
        case "date":
          group[col.name] =
            col.required && col.listVisible
              ? new UntypedFormControl(!entity ? new Date() : entity[col.name] || new Date(), Validators.required)
              : new UntypedFormControl(!entity ? new Date() : entity[col.name] || new Date());
          break;
        default:
          group[col.name] =
            col.required && col.listVisible
              ? new UntypedFormControl(!entity ? "" : entity[col.name] || "", Validators.required)
              : new UntypedFormControl(!entity ? "" : entity[col.name] || "");
          break;
      }
    });
    group["State"] = new UntypedFormControl(!entity ? RowState.New : entity["State"] || RowState.NoChange);
    group["Id"] = new UntypedFormControl(!entity ? 0 : entity["Id"] || RowState.NoChange);
    group["RowVersion"] = new UntypedFormControl(!entity ? "" : entity["RowVersion"] || "");

    if (this.RowNumberName)
      group[this.RowNumberName] = new UntypedFormControl(!entity ? this.gridData.length + 1 : entity[this.RowNumberName] || RowState.NoChange);
    this.formGroup = new UntypedFormGroup(group);

    this.columns.forEach((x) => {
      if (this.DefaultValues[x.name] !== undefined) {
        if (!this.formGroup.controls[x.name].value) this.formGroup.controls[x.name].setValue(this.DefaultValues[x.name]);
      }
    });
    this.setChanges();
  }
  setColumnWith() {
    this.columns.forEach((x) => {
      if (
        x.textType === "number" &&
        x.withComma &&
        !x.name.toUpperCase().includes("NUMBER") &&
        !x.name.toUpperCase().includes("CODE") &&
        !x.name.toUpperCase().includes(".ID")
      )
        x.format = "#,#.#####";
      else x.format = "##";
      if (!x.columnWidth || x.columnWidth <= 100) {
        if (x.textType === "text") x.columnWidth = 200;
        else x.columnWidth = 100;
      }
      if (x.name === "BranchTitle") x.disabled = true;
    });
  }
  public addHandler() {
    if (this.newdefaultRowTregger) this.setFormGroup(this.newdefaultRowTregger({}, undefined));
    else this.setFormGroup();
    this.isNew = true;
    this.rowIsEditing = true;
    this.formGroup.get("State").setValue(RowState.New);
    this.grid?.addRow(this.formGroup);
    this.editedRowIndex = -1;
    this.onRowSelected.emit(this.formGroup.value);
    this.cd.markForCheck();
  }

  public cancelHandler() {
    this.afterDeleted.emit(this.formGroup?.value);
    this.closeEditor();
  }

  getDateValue(date: Date) {
    let m: Moment = moment(date.toString()).locale("fa");
    return m.format("YYYY/MM/DD");
  }
  private getDataFromFormGroup(): any {
    let model: any = {};
    Object.keys(this.formGroup.controls).forEach((key) => {
      model[key] = this.formGroup.controls[key].value;
    });
    return model;
  }

  public saveHandler(rowIndex, formGroup): void {
    if (this.formGroup && this.formGroup?.valid) {
      this.valueChanges.emit(this.formGroup);
      this.formGroup.markAllAsTouched();
      var entity = this.getDataFromFormGroup();
      this.setIsDefault(entity, rowIndex);
      if (entity.State === undefined || (entity.State === RowState.New && rowIndex === -1)) {
        entity.State = RowState.New;
        entity["RowNumber"] = this.dataList.length + 100;
        let mask = this.columns.filter((x) => x.inputMask);
        if (mask && mask.length > 0) {
          mask.forEach((m) => {
            if (entity[m.name]) entity[m.name] = this.getDeMaskedAmount(entity[m.name], m.inputMask);
          });
        }
        this.dataList.push(entity);
      } else if (rowIndex >= 0) {
        let mask = this.columns.filter((x) => x.inputMask);
        if (mask && mask.length > 0) {
          mask.forEach((m) => {
            if (entity[m.name]) entity[m.name] = this.getDeMaskedAmount(entity[m.name], m.inputMask);
          });
        }
        if (!entity.State) entity.State = this.dataList[rowIndex].State;
        if (entity.State != RowState.New) (entity as EntityBase).State = RowState.Modify;
        this.dataList[rowIndex] = entity;
      }
      this.afterSaved.emit(entity);
      if (this.filtering || this.paging) this.dataStateChange(this.state);
      this.rowIsEditing = false;
      if (formGroup.valid) {
        this.grid?.closeRow(rowIndex);
      }
      //this.refreshform();
    } else this.sts.showDialog(`اطلاعات وارده صحیح نیست.`, "خطا", DialogType.alert);
    this.gridData = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.cd.markForCheck();
  }
  deleteFormHelper(dataItem: any) {
    this.dataList.forEach((x) => {
      if (
        (dataItem.Id && dataItem.Id !== 0 && x.Id === dataItem.Id) ||
        (dataItem["RowNumber"] && dataItem["RowNumber"] !== 0 && x["RowNumber"] === dataItem["RowNumber"]) ||
        x === dataItem
      ) {
        if (x.State === RowState.New) x.State = RowState.Detached;
        else x.State = RowState.Delete;
      }
    });
    this.gridData = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.afterDeleted.emit(dataItem);
    if (this.filtering) this.dataStateChange(this.state as DataStateChangeEvent);
    this.cd.markForCheck();
  }
  public removeHandler({ sender, dataItem }): void {
    this.sts.showDialog(`آیا از حذف اطلاعات اطمینان دارید؟`, "حذف اطلاعات", DialogType.confirm, () => this.deleteFormHelper(dataItem));
    sender.cancelCell();
  }

  private closeEditor() {
    if (this.editedRowIndex !== undefined) this.grid?.closeRow(this.editedRowIndex);
    else this.grid?.closeRow(-1);
    this.rowIsEditing = false;
    this.isNew = false;
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }
  setIsFreeDelivery() {
    if (this.formGroup && this.formGroup.controls["IsFreeDelivery"]) {
      this.grid?.columns.forEach((c) => {
        if (c["field"] === "MinimumPurchaseForFreeShipping") c["editable"] = this.formGroup.controls["IsFreeDelivery"].value;
      });
    }
  }
  private isReadOnly(field: string, dataItem: any): boolean {
    if (this.formGroup) this.setIsFreeDelivery();
    if (!dataItem["IsFreeDelivery"] && field === "MinimumPurchaseForFreeShipping") return true;
    if (this.formGroup) {
      this.getSelected(dataItem);
      this.formGroup.controls["MinimumPurchaseForFreeShipping"].setValue(this.formGroup.controls["MinimumPurchaseForFreeShipping"].value);
    }
    let col = this.columns.find((x) => x.name === field);
    return col && col.disabled;
  }
  public saveCurrent(): void {
    if (this.formGroup) {
      this.saveHandler(this.editedRowIndex, this.formGroup);
      this.closeEditor();
    }
  }

  onOpen(ddl: DropDownListComponent) {
    // Fixed the problem of opening the dropdown in mobile mode
    const popupService = ddl["popupService"] as any;
    popupService["appendPopup"] = (nodes, container) => {
      const popupComponentRef = popupService.createComponent(PopupComponent, nodes, container);
      if (popupComponentRef?.instance?.offset?.left) {
        popupComponentRef.instance.offset.left = 0;
      }
      if (!container) {
        popupService.rootViewContainerNode.appendChild(popupService.getComponentRootNode(popupComponentRef));
      }
      return popupComponentRef;
    };
  }

  public cellClickHandler({ sender, rowIndex, column, columnIndex, dataItem, isEdited }): void {
    if (!this.isAdd && !this.isEdit) return;
    if (this.rowEditableKeyNotAllow && dataItem[this.rowEditableKeyNotAllow] == true) return;
    this.setMaskedInfo();
    this.checkDropdownlist();
    if (this.rowseleted) {
      this.cancelHandler();
      this.rowseleted = false;
    }
    this.onRowSelected.emit(dataItem);
    if (this.formGroup !== undefined) {
      if (!column || isEdited) {
        return;
      }
    }
    if (this.formGroup) {
      this.valueChanges.emit(this.formGroup);
      this.formGroup.markAllAsTouched();
      this.setIsFreeDelivery();
    }

    if (this.formGroup && this.formGroup?.valid) {
      this.selectionChange(undefined, undefined, undefined, undefined, this.formGroup.value, column?.custom);
      if (this.formGroup?.valid) this.saveCurrent();
      else return;
    } else if (this.formGroup && !this.formGroup?.valid) return;
    if (this.isNew && this.formGroup && this.formGroup?.valid) {
      rowIndex += 1;
    }
    if (this.formGroup && this.formGroup?.valid) this.saveCurrent();
    this.setIsDefault(dataItem, rowIndex);
    this.setFormGroup(dataItem);
    if (dataItem) {
      this.getSelected(dataItem);
    }
    if (this.formGroup) this.setValidation();
    this.rowIsEditing = true;
    this.editedRowIndex = rowIndex;
    if (this.isAdd || this.isEdit) this.grid?.editRow(rowIndex, this.formGroup, { columnIndex });
    if (this.formGroup) this.formGroup.markAllAsTouched();
  }
  checkDropdownlist() {
    this.columns.forEach((x) => {
      if (x.apiName && !this.LookupData[x.apiName] && !this.hasMultiColumns(x.columnsName))
        this.setDropdownlist(x.apiName, x.systemName, x.category, x.name);
    });
  }
  setDropdownlist(apiName: string, systemName: string, category: string, key: string) {
    if (this.selectorService.getDataList(apiName)) {
      return;
    }
    if (this.formGroup) this.formGroup.markAllAsTouched();

    if (apiName.includes("MonthsName")) {
      this.LookupData[apiName] = this.monthsnameService.MonthList;
    } else if (systemName && category && !this.loadingData) {
      this.lookupservice
        .getLookupbyCategory(systemName, category)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.LookupData[apiName] = x;
        });
    } else
      this._httpCommonService
        .getList(apiName)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.LookupData[apiName] = x;
        });
    this.valueChanges.emit(undefined);
  }
  getValue(val: any) {
    return val;
  }
  getItemDisplayById(
    apiName: string,
    systemName: string,
    id: number,
    displayMember: string,
    valueMember: string,
    columnName: string,
    dataItem: any,
    isMultiSelect: boolean = false
  ) {
    if (isMultiSelect) {
      let result = "";
      dataItem[columnName]?.forEach((element, ind) => {
        result += element[displayMember] + (dataItem[columnName].length - 1 != ind ? "," : "");
      });
      return result;
    } else {
      if (!id) return "";

      if (columnName === "PartyId") return dataItem[displayMember];
      if (systemName) {
        return this.lookupservice.getLookupbyId(id)?.Title;
      } else {
        if (columnName === "Month") return this.monthsnameService.MonthList.find((x) => x.Id === dataItem[columnName]).Title;
        if (dataItem[columnName.replace("Id", displayMember)]) return dataItem[columnName.replace("Id", displayMember)];

        if (displayMember.includes("UnitId") && dataItem[`${displayMember.replace("UnitId", "UnitTitle")}`])
          return dataItem[`${displayMember.replace("UnitId", "UnitTitle")}`];

        if (this.LookupData[apiName] && this.LookupData[apiName].find((x) => x[valueMember] === id)) {
          if (this.LookupData[apiName].find((x) => x[valueMember] === id)[displayMember])
            return this.LookupData[apiName].find((x) => x[valueMember] === id)[displayMember];
          else return this.LookupData[apiName].find((x) => x[valueMember] === id)[columnName];
        }
      }
      if (dataItem[`Goods${displayMember}`]) return dataItem[`Goods${displayMember}`];
      if (dataItem[columnName]) return dataItem[columnName];
      return "";
    }
  }
  setValidation() {
    this.columns.forEach((x) => {
      if (x.apiName) {
        let event: any;
        if ((x.systemName, x.category)) event = this.lookupservice.getLookupbyId(this.formGroup.controls[x.name].value);
        else if (this.LookupData[x.apiName] !== undefined) {
          event = this.LookupData[x.apiName].find((f) => f[x.valueMember] === this.formGroup.controls[x.name].value);
          if (event !== undefined) this.selectionChange(event, "", "", "", undefined, x["custom"]);
        }
      }
    });
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }
  getSelected(dataItem: any) {
    if (!this.formGroup) return;
    if (this.formGroup.get("Selected") && this.formGroup.controls["State"]) {
      if (this.formGroup.controls["State"].value !== RowState.New) this.formGroup.get("Selected").disable();
      else this.formGroup.get("Selected").enable();
    }

    if (this.formGroup.get("IsActive") && this.formGroup.controls["Selected"]) {
      if (!this.formGroup.controls["Selected"].value) this.formGroup.get("IsActive").disable();
      else this.formGroup.get("IsActive").enable();
    }
    if (this.formGroup.get("MinimumPurchaseForFreeShipping") && this.formGroup.controls["IsFreeDelivery"]) {
      if (!this.formGroup.controls["IsFreeDelivery"].value) this.formGroup.get("MinimumPurchaseForFreeShipping").disable();
      else this.formGroup.get("MinimumPurchaseForFreeShipping").enable();
    }
    this.formGroup.updateValueAndValidity();
  }
  setIsDefault(dataItem: any, rowIndex: number) {
    let index = 0;
    if (dataItem["IsDefault"] && dataItem["IsDefault"] === true) {
      this.dataList.forEach((x) => {
        if (index != rowIndex && x["IsDefault"] === true) {
          x["IsDefault"] = false;
          if (x["State"] === RowState.NoChange) x["State"] = RowState.Modify;
        }
        index = index + 1;
      });
    }
    this.gridData = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
    this.cd.markForCheck();
  }
  getcheckedKeys(key: string) {
    let checkedKeys: any[] = [];
    this.dataList
      .filter((x) => x.State != RowState.Delete && x.State != RowState.Detached)
      .forEach((x) => {
        checkedKeys.push(x[key]);
      });
    return checkedKeys;
  }
  multiSelectValueChange(newValue: any, column: form_control, dataItem: any) {
    if (column.isSelector) this.selectionChange(newValue, column.name, column.valueMember, column.displayMember, dataItem);
    else this.valueChange.emit(newValue);
    this.cd.markForCheck();
  }
  onDropdownClose(e) {
    console.log(e);
  }

  selectionChange(event: any, key: string, valueMember: string, displayMember: string, dataItem: any, isCustom?: boolean) {
    this.onLookupChanges.emit({ event, key, valueMember, displayMember, dataItem, formGroup: this.formGroup });
    if (event && event.data && event.data.length > 0) {
      event.data.forEach((x) => {
        if (x) {
          let entity = this.newdefaultRowTregger ? this.newdefaultRowTregger({}, x) : {};
          entity["State"] = RowState.New;
          if (isCustom) {
            entity[key] = x[displayMember];
            entity[key.replace("Title", valueMember)] = x[valueMember];
            if (x["Title"]) entity[key] = x["Title"];
            if (x["Id"]) entity[key.replace("Title", "Id")] = x["Id"];
            if (!this.dataList.some((f) => f[key] === x[valueMember] && f["State"] !== RowState.Detached && f["State"] !== RowState.Delete)) {
              entity["RowNumber"] = this.dataList.length + 100;
              this.dataList.push(entity);
            }
          } else {
            entity[key] = x[valueMember];
            entity[key.replace("Id", displayMember)] = x[displayMember];
            if (x["Title"]) entity[key.replace("Id", "Title")] = x["Title"];
            if (!this.dataList.some((f) => f[key] === x[valueMember] && f["State"] !== RowState.Detached && f["State"] !== RowState.Delete)) {
              entity["RowNumber"] = this.dataList.length + 100;
              if (!this.dataList.some((s) => s.State != RowState.Delete && s.State != RowState.Detached && s[key] === entity[key]))
                this.dataList.push(entity);
            }
          }
        }
      });
      this.gridData = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
      this.cd.markForCheck();
      this.closeEditor();
    }

    if (!this.formGroup) return;
    this.currentLookup = event;
    this.valueChanges.emit(event);
    if (
      !this.noReduplicative &&
      key &&
      valueMember &&
      displayMember &&
      event !== undefined &&
      event[valueMember] !== undefined &&
      (isCustom ? dataItem[key.replace("Title", "Id")] : dataItem[key]) !== event[valueMember] &&
      this.dataList.some(
        (f) =>
          f[isCustom ? dataItem[key.replace("Title", "Id")] : dataItem[key]] === event[valueMember] &&
          f["State"] !== RowState.Detached &&
          f["State"] !== RowState.Delete
      )
    ) {
      this.sts.showDialog(`این قلم ${event[displayMember]} قبلا انتخاب شده است.`, "هشدار", DialogType.alert);
      this.closeEditor();
      return;
    }

    if (event && event[displayMember]) {
      if (key === "PartyId") this.formGroup.controls["DisplayName"].setValue(event[displayMember]);
      if (isCustom) {
        if (this.formGroup.controls[key.replace("Title", "Code")]) this.formGroup.controls[key.replace("Title", "Code")].setValue(event["Code"]);
        if (this.formGroup.controls[key.replace("Title", "Id")]) this.formGroup.controls[key.replace("Title", "Id")].setValue(event["Id"]);
      } else {
        if (this.formGroup.controls[key.replace("Id", "Code")]) this.formGroup.controls[key.replace("Id", "Code")].setValue(event["Code"]);
        if (this.formGroup.controls[key.replace("Id", "Title")]) this.formGroup.controls[key.replace("Id", "Title")].setValue(event["Title"]);
        if (this.formGroup.controls[key.replace("Id", displayMember)])
          this.formGroup.controls[key.replace("Id", displayMember)].setValue(event[displayMember]);
        else if (this.formGroup.controls[key]) {
          this.setValue(key.replace("Id", displayMember), event[displayMember]);
          this.setValue(key.replace("Id", "Code"), event[key.replace("Id", "Code")]);
          this.setValue(key.replace("Id", "Title"), event[key.replace("Id", "Title")]);
        }
      }
    }
    if (event && event.UnitId) {
      if (this.formGroup.controls["MainUnitId"]) this.formGroup.controls["MainUnitId"].setValue(event.UnitId);
      if (this.formGroup.controls["GoodsUnitId"] && event.DefaultUnitId && this.formGroup.controls["GoodsUnitId"].value != event.UnitId)
        this.formGroup.controls["GoodsUnitId"].setValue(event.DefaultUnitId);
      else if (this.formGroup.controls["GoodsUnitId"]) this.formGroup.controls["GoodsUnitId"].setValue(event.UnitId);
      if (this.formGroup.controls["GoodsUnitTitle"]) this.formGroup.controls["GoodsUnitTitle"].setValue(event.UnitTitle);
      if (this.formGroup.controls["GoodsDefaultUnitTitle"]) this.formGroup.controls["GoodsDefaultUnitTitle"].setValue(event.DefaultUnitTitle);
      if (this.formGroup.controls["GoodsUnitRatio"] && event.Ratio && this.formGroup.controls["GoodsUnitRatio"].value != event.Ratio)
        this.formGroup.controls["GoodsUnitRatio"].setValue(event.Ratio);
    }
    if (event && event.DefaultUnitId) {
      if (this.formGroup.controls["MainUnitId"]) this.formGroup.controls["MainUnitId"].setValue(event.UnitId);
      if (this.formGroup.controls["UnitId"]) this.formGroup.controls["UnitId"].setValue(event.UnitId);
      if (this.formGroup.controls["GoodsUnitId"] && this.formGroup.controls["GoodsUnitId"].value != event.UnitId)
        this.formGroup.controls["GoodsUnitId"].setValue(event.DefaultUnitId);

      if (this.formGroup.controls["GoodsUnitRatio"] && this.formGroup.controls["GoodsUnitRatio"].value != event.DefaultUnitRatio)
        this.formGroup.controls["GoodsUnitRatio"].setValue(event.DefaultUnitRatio ?? 1);

      if (this.formGroup.controls["GoodsMainUnitTitle"]) this.formGroup.controls["GoodsMainUnitTitle"].setValue(event.UnitTitle);
      if (this.formGroup.controls["GoodsUnitTitle"] && this.formGroup.controls["GoodsUnitTitle"].value != event.UnitTitle)
        this.formGroup.controls["GoodsUnitTitle"].setValue(event.DefaultUnitTitle);
    }
    if ((event && event.Category && event.Category === "NumberType") || (dataItem && dataItem.NumberTypeCode)) {
      this.setPhoneValidators(event.Code);
    }
    if (event && (event.CourierShippingCost || event.ShippingCost)) {
      if (this.formGroup.controls["ShippingCost"]) this.formGroup.controls["ShippingCost"].setValue(event.ShippingCost);
      if (this.formGroup.controls["CourierShippingCost"]) this.formGroup.controls["CourierShippingCost"].setValue(event.CourierShippingCost);
    }
  }

  setPhoneValidators(code: number) {
    if (this.formGroup.controls["Number"]) {
      this.formGroup.controls["Number"].clearValidators();
      this.formGroup.controls["Number"].setErrors(null);

      if (code === NumberType.Mobile || this.formGroup.controls["NumberTypeCode"]?.value === NumberType.Mobile)
        this.formGroup.controls["Number"].setValidators([Validators.required, Validators.pattern("^[0-0][9-9]\\d{9}")]);
      else this.formGroup.controls["Number"].setValidators([Validators.required, Validators.pattern("^[1-9]\\d{3,7}")]);
      this.formGroup.controls["Number"].setValue(this.formGroup.controls["Number"].value);
      this.formGroup.updateValueAndValidity();
    }
  }

  refreshform() {
    setTimeout(() => this.addHandler(), 100);
    setTimeout(() => this.cancelHandler(), 200);
  }
  setMaskedInfo() {
    if (!this.formGroup) return;
    let mask = this.columns.filter((x) => x.inputMask);
    if (mask && mask.length > 0) {
      mask.forEach((m) => {
        if (this.formGroup.get(m.name) && this.formGroup.get(m.name).value && typeof this.formGroup.get(m.name).value === "number") {
          let value: string = this.formGroup.get(m.name).value.toString();
          if (value.length < m.inputMask.length - 1) value = "0".repeat(m.inputMask.length - 1 - value.length) + value;
          this.formGroup.get(m.name).setValue(value);
        }
      });
      this.formGroup.updateValueAndValidity();
    }
  }
  getMaskedAmount(amount: number, inputMask: string) {
    try {
      if (!amount) return "";
      if (inputMask === "00" && isNumber(amount) && amount >= 440) {
        let temp: number = amount / 440;
        if (temp.toString().length > 2) return temp;
        return "0".repeat(2 - temp.toString().length) + temp;
      }
      if (inputMask === "000:00" && isNumber(amount)) {
        let temp: number = amount % 60;
        let MM = (amount - temp) / 60;
        return "0".repeat(3 - MM.toString().length) + MM + ":" + "0".repeat(2 - temp.toString().length) + temp;
      }
      if (inputMask === "00:00:00" && isNumber(amount)) {
        let temp1: number = amount % 440;
        let temp2: number = temp1 % 60;
        let DD = (amount - temp1) / 440;
        let MM = (temp1 - temp2) / 60;
        return (
          "0".repeat(2 - DD.toString().length) +
          DD +
          ":" +
          "0".repeat(2 - MM.toString().length) +
          MM +
          ":" +
          "0".repeat(2 - temp2.toString().length) +
          temp2
        );
      }
      if (inputMask === "00:00" && isNumber(amount)) return "0".repeat(2 - amount.toString().length) + amount;

      return amount;
    } catch (e) {
      console.log(e);
    }
  }
  getDeMaskedAmount(amount: string, inputMask: string) {
    if (!amount) return 0;
    if (amount.toString().indexOf("_") > -1) amount = amount.replace(/\_/g, "");
    if (inputMask === "00") {
      return Number(amount) * 440;
    }
    if (inputMask === "000:00") {
      return Number(amount.replace(":", "").substr(0, 3)) * 60 + Number(amount.replace(":", "").substr(3, 2));
    }
    if (inputMask === "00:00:00") {
      return (
        Number(amount.replace(":", "").substr(0, 2)) * 440 +
        Number(amount.replace(":", "").substr(2, 2)) * 60 +
        Number(amount.replace(":", "").substr(5, 2))
      );
    }
    return Number(amount);
  }
  setColumnInfo() {
    if (!this.grid) return;
    this.grid?.columns.forEach((x: ColumnComponent) => {
      const column = this.columns.find((c) => c.name === (x.field ?? x.title));
      if (column) {
        x.minResizableWidth = x.minResizableWidth;
        x.width = column.columnWidth;
      }
    });
    this.grid?.focus();
  }

  fitColumns(): void {
    if (this.grid && !this.noAutoFitColumns) {
      setTimeout(() => {
        this.ngZone.onStable
          .asObservable()
          .pipe(take(1))
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(() => {
            this.grid?.autoFitColumns();
            this.setColumnInfo();
          });
      }, 100);
    }
    this.cd.markForCheck();
  }

  public pageChange(event: PageChangeEvent): void {
    this.state.skip = event.skip;
    this.state.take = event.take;
    this.dataStateChange(this.state);
  }

  hasMultiColumns(ColumnsName: string) {
    if (!ColumnsName) return false;
    var columns = ColumnsName.split(",");
    return columns.length > 1;
  }
  onRowsSelected($event, key: string, valueMember: string, displayMember: string, isCustom: boolean) {
    if ($event && $event.length > 0) {
      this.rowseleted = true;
      $event.forEach((x) => {
        let entity = this.newdefaultRowTregger ? this.newdefaultRowTregger({}, x) : {};
        entity["State"] = RowState.New;
        if (isCustom) {
          entity[key] = x[displayMember];
          entity[key.replace("Title", valueMember)] = x[valueMember];
          if (x["Title"]) entity[key] = x["Title"];
          if (x["Id"]) entity[key.replace("Title", "Id")] = x["Id"];
          if (
            !this.dataList.some(
              (f) => f[key.replace("Title", "Id")] === x[valueMember] && f["State"] !== RowState.Detached && f["State"] !== RowState.Delete
            )
          ) {
            entity["RowNumber"] = this.dataList.length + 100;
            this.dataList.push(entity);
          }
        } else {
          entity[key] = x[valueMember];
          entity[key.replace("Id", displayMember)] = x[displayMember];
          if (x["Title"]) entity[key.replace("Id", "Title")] = x["Title"];
          if (!this.dataList.some((f) => f[key] === x[valueMember] && f["State"] !== RowState.Detached && f["State"] !== RowState.Delete)) {
            entity["RowNumber"] = this.dataList.length + 100;
            this.dataList.push(entity);
          }
        }
      });
      this.gridData = this.dataList.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached);
      this.cd.markForCheck();
      this.closeEditor();
      this.valueChanges.emit(this.formGroup);
    }
  }

  getColumnAggregates(columnName: string) {
    if (this.dataList.length > 0) return this.dataList.reduce((s: number, b: number) => s + b[columnName], 0);
    return undefined;
  }
  setAggregates() {
    if (!this.aggregatesColumnName) return;
    var keys = this.aggregatesColumnName.split(",");
  }
  hasAggregate(columnName: string) {
    return this.aggregatesColumnName !== undefined && this.aggregatesColumnName.includes(columnName);
  }
  setSelectedRows(e: any, items: any[]) {
    if (!this.selectedRows) this.selectedRows = [];
    items.forEach((x) => {
      if (x.items) this.setSelectedRows(e, x.items);
      else if (!this.selectedRows.some((s) => s["Id"] === x["Id"])) this.selectedRows.push(x);
    });
  }
  public onSelectedKeysChange(e) {
    const len = e.length;
    if (len === 0) {
      this.selectAllState = "unchecked";
    } else if (len > 0 && len < this.gridData.length) {
      this.selectAllState = "indeterminate";
    } else {
      this.selectAllState = "checked";
    }
    if (this.isMulti) {
      if (e && e.length > 0) {
        if (this.gridData[0].items) this.setSelectedRows(e, this.gridData[0].items);
        else this.selectedRows = this.gridData.filter((x) => e.some((s) => s === x[this.SelectById]));
      } else this.selectedRows = [];
    }
    if (this.isMulti) {
      if (this.mySelection && this.mySelection.length > 0) {
        if (this.selectedRows && this.selectedRows.length > 0)
          this.selectedRows = this.selectedRows.filter((x) => this.mySelection.some((s) => s === x[this.SelectById]));
        else this.selectedRows = [];
      }
      this.onRows_Selected.emit(this.selectedRows);
    }
  }
  public onSelectAllChange(checkedState: SelectAllCheckboxState) {
    if (checkedState === "unchecked" && this.mySelection.length <= 0) {
      this.mySelection = this.gridData.map((item) => item[this.SelectById]);
      this.onSelectedKeysChange(this.mySelection);
    }
    if (checkedState === "checked") {
      this.mySelection = this.gridData.map((item) => item[this.SelectById]);
      this.selectAllState = "checked";
    } else {
      this.mySelection = [];
      this.selectAllState = "unchecked";
    }
  }
}
